
import CtrlFormularioDinamicoPage from './pages/CtrlFormularioDinamicoPage.vue'
import NovoFormularioPage from './pages/NovoFormularioPage.vue';

const routes = [
    {
        path: 'ctrl-formularios-dinamicos',
        name: 'ctrl-formularios-dinamicos',
        component: CtrlFormularioDinamicoPage 
    },
    {
        path: 'ctrl-formularios-dinamicos/novo',
        name: 'ctrl-formularios-dinamicos-novo',
        component: NovoFormularioPage 
    },
    {
        path: 'ctrl-formularios-dinamicos/:id',
        name: 'ctrl-formularios-dinamicos-edit',
        component: NovoFormularioPage 
    }
];

export default routes;